import api from "./client";

export const getAllEnquiries = async (agentId) => {
  try {
    const response = await api.get(`/agent/booking-enquiries/${agentId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const pickupEnquiry = async (enquiryId, agentId) => {
  const response = await api.post(`/agent/booking-enquiries/${enquiryId}/pickup`, {
    agent_id: agentId,
  });
  return response.data;
};

export const createBookingFromEnquiry = async (enquiryId, payload) => {
  const response = await api.post(
    `/agent/booking-enquiries/${enquiryId}/create-booking`,
    payload
  );
  return response.data;
};

/** Room numbers unavailable for this stay (confirmed or paid overlaps). */
export const fetchBlockedRoomNumbers = async (hotelId, checkInIso, checkOutIso) => {
  const response = await api.get(`/agent/blocked-room-numbers/${hotelId}`, {
    params: { checkIn: checkInIso, checkOut: checkOutIso },
  });
  return response.data;
};
